<template>
  <div class="container flex-horizontal">
    <div
      v-for="tab in openTabs"
      :key="tab.name"
      class="tab-box"
      @click="selectTab(tab)"
    >
      {{ $tc(tab.display, 2) }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["openTabs"],
  methods: {
    selectTab(tab) {
      this.$emit("selectTab", tab);
    }
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
}
.tab-box {
  width: 120px;
  height: 120px;
  margin: auto;
  background: var(--secondary-darker);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tab-box:hover {
  border: 1px solid var(--primary-highlight);
  color: var(--primary-highlight);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/TabSelection.vue